<template>
  <div style="width: 70%">
    <b-loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></b-loading>

    <b-message v-if="isCloned" size="is-small"
               title="This game is a clone. If you edit it, it won't be grouped with the original game anymore."
               type="is-danger">
    </b-message>

    <form>
      <b-field :message="{ 'Name cannot be blank': errorGameName }" :type="{ 'is-danger': errorGameName }"
               horizontal
               label="Name*:">
        <b-input
            v-model="gameName"
            :has-counter="false"
            maxlength="15"
            placeholder="Game name"
        >
        </b-input>
      </b-field>
      <b-field :message="{ 'Description cannot be blank': errorDescription }" :type="{ 'is-danger': errorDescription }"
               horizontal
               label="Description*:">
        <b-input
            v-model="gameDescription"
            placeholder="Short description of your game"
        >
        </b-input>
      </b-field>
      <b-field horizontal label="Image:">
        <div style="position: relative">
          <picture-input
              id="pictureInput"
              ref="challengePicture"
              :customStrings="fileUploadCustomTexts"
              :prefill="image"
              :removable="true"
              buttonClass="button is-primary is-outlined"
              height="150"
              removeButtonClass="button is-outlined"
              width="250"
              @change="onPictureSelected"
              @remove="onPictureRemoved"
          />
          <div v-if="imagePreviewUrl" id="injectedPreview" style="background-color: white">
            <img id="injectedPreviewImage" :src="imagePreviewUrl" alt="photo"/>
          </div>
          <button v-if="imagePreviewUrl" class="button is-info is-outlined"
                  style="width: 250px; margin-top: 55px;"
                  @click.prevent="hideImagePreview">
            Change image
          </button>
        </div>
      </b-field>
      <b-field :message="{ 'Game style cannot be blank': errorGameStyle }" :type="{ 'is-danger': errorGameStyle }"
               horizontal
               label="Game style:">
        <b-select v-model="gameStyle" placeholder="Pick a style" rounded>
          <option
              v-for="(styl, index) in gameStyles"
              :key="index"
              :value="styl">
            {{ styl }}
          </option>
        </b-select>
        <div v-if="gameStyle === gameStyleTimeAttack" style="margin-top: 8px; font-style: italic">
          You will have to enter a duration in the coming screens.
        </div>
      </b-field>
      <b-field :message="{ 'Access type cannot be blank': errorAccessType }" :type="{ 'is-danger': errorAccessType }"
               horizontal
               label="Game access:">
        <b-select v-model="accessType" placeholder="Private or public?" rounded>
          <option
              v-for="(accType, index) in accessTypes"
              :key="index"
              :value="accType">
            {{ accType | capitalize }}
          </option>
        </b-select>
      </b-field>
    </form>
  </div>
</template>

<script>
import gameStylesHelper from '../../enums/gameStyles'
import GAME_ACCESS_TYPES from '../../enums/accessTypes'
import PictureInput from 'vue-picture-input'
import imageHelper from '../../helpers/image-helper'
import textHelper from '../../helpers/text-helper'

export default {
  components: {
    PictureInput,
  },
  props: {
    game: {},
    next: false,
    isEdit: false,
  },
  data() {
    return {
      isLoading: false,
      imagePreviewUrl: '',
      gameName: '',
      gameDescription: '',
      gameStyle: '',
      accessType: 'private',
      isCloned: false,

      gameStyles: [],
      accessTypes: [],
      image: '',
      fileUploadCustomTexts: {
        upload: '<h1>Your device does not support file uploading.</h1>',
        drag: 'Drag file here or click here to upload'
      },

      errorGameName: false,
      errorDescription: false,
      errorGameStyle: false,
      errorAccessType: false,
      gameStyleTimeAttack: '',
    }
  },
  watch: {
    'next': function (next) {
      if (next) {

        if (!this.validateFields()) {
          console.log('Errors in fields')
          this.$emit('errors')
          return
        }

        const step1Game = {
          gameName: this.gameName,
          gameDescription: this.gameDescription,
          gameStyle: this.gameStyle,
          image: this.image,
          accessType: this.accessType,
        }

        if (this.isEdit) {
          step1Game.existingLogo = this.imagePreviewUrl
        }

        console.log('Before emit in Next Step 1')
        this.$emit('updated', step1Game)
      }
    }
  },
  created() {
    this.gameStyles = _.filter(Object.values(gameStylesHelper.GAME_STYLES), (style) => {
      return !gameStylesHelper.disabledGameStyles(style)
    })
    this.gameStyle = gameStylesHelper.GAME_STYLES.CLASSIC
    this.gameStyleTimeAttack = gameStylesHelper.GAME_STYLES.TIME_ATTACK

    this.accessTypes = GAME_ACCESS_TYPES
    this.accessType = GAME_ACCESS_TYPES.PRIVATE

    if (this.isEdit) {
      this.isLoading = true

      this.gameName = this.game.gameName
      this.gameDescription = this.game.gameDescription
      this.gameStyle = this.game.gameStyle
      this.accessType = this.game.accessType

      if (this.game.image) {
        this.image = this.game.image
        this.imagePreviewUrl = ''
      } else {
        this.imagePreviewUrl = this.game.imageUrl
      }

      this.isCloned = !!this.game.groupId

      this.isLoading = false
    } else {
      if (this.game) {
        this.gameName = this.game.gameName ? this.game.gameName : ''
        this.gameDescription = this.game.gameDescription ? this.game.gameDescription : ''
        this.gameStyle = this.game.gameStyle ? this.game.gameStyle : this.gameStyle
        this.image = this.game.image ? this.game.image : null
        this.accessType = this.game.accessType ? this.game.accessType : this.accessType
      }
    }
  },
  filters: {
    capitalize(s) {
      return textHelper.capitalize(s)
    },
  },
  methods: {
    onPictureSelected(image) {
      if (image) {
        imageHelper.compressImg(this.$refs.challengePicture.image)
            .then((compressedChallengePic) => {
              this.image = compressedChallengePic
            })
      }
    },
    onPictureRemoved() {
      this.image = null
    },
    hideImagePreview() {
      this.imagePreviewUrl = ''
    },
    validateFields() {
      let hasErrors = false
      if (!this.gameName) {
        this.errorGameName = true
        hasErrors = true
      }
      if (!this.gameDescription) {
        this.errorDescription = true
        hasErrors = true
      }
      if (!this.gameStyle) {
        this.errorGameStyle = true
        hasErrors = true
      }
      if (!this.accessType) {
        this.errorAccessType = true
        hasErrors = true
      }

      return !hasErrors
    }
  }
}
</script>
<style scoped>
.picture-input /deep/ .preview-container {
  margin: 0;
  z-index: 1 !important;
}

.picture-input /deep/ .picture-preview {
  margin: 0;
  z-index: 1 !important;
}

.picture-input /deep/ .picture-inner {
  z-index: 1 !important;
}

.picture-input {
  text-align: left !important;
}

.picture-input /deep/ .preview-container {
  margin: 0;
}

#pictureInput, #injectedPreview {
  height: 200px;
  width: 250px;
  position: absolute;
}

#injectedPreviewImage {
  height: 200px;
  width: 250px;
}

#injectedPreview {
  top: 0;
  z-index: 10;
}
</style>
